export default __webpack_public_path__ + "static/media/customer-list-light.3e1de958.svg";